<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="用户姓名" :value="1"></el-option>
                            <el-option label="用户ID" :value="2"></el-option>
                            <el-option label="手机号" :value="3"></el-option>
                            <el-option label="公司邮箱" :value="4"></el-option>
                            <el-option label="角色" :value="5"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制状态" :value="-1"></el-option>
                        <el-option label="仅看正常的" :value="1"></el-option>
                        <el-option label="仅看禁用的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.department" placeholder="请输入部门" size="small" clearable></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/adminUser/add')" type="primary" @click="add" size="small">添加员工</el-button>
            <el-button v-if="$utils.have('/access/log/list')" type="primary" @click="log()" size="small">员工行为日志</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" size="mini" type="success">正常</el-tag>
                        <el-tag v-else size="mini" type="info">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <!-- <el-table-column prop="accName" label="账号"></el-table-column> -->
                <el-table-column prop="nameZh" label="姓名" show-overflow-tooltip></el-table-column>
                <el-table-column label="角色" prop="roleNames" show-overflow-tooltip></el-table-column>
                <el-table-column prop="tel" label="手机" min-width="110"></el-table-column>
                <el-table-column prop="mail" label="公司邮箱" min-width="200"></el-table-column>
                <el-table-column prop="department" label="部门" show-overflow-tooltip></el-table-column>
                
                <!-- <el-table-column prop="k3cloudUserId" label="金蝶员工内码(ID)" min-width="120"></el-table-column>
                <el-table-column prop="k3cloudUserNumbers" label="金蝶员工编码(numbers)" min-width="160"></el-table-column> -->
                <el-table-column fixed="right" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/adminUser/edit')"
                            type="text"
                            size="small"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/adminUser/bindingRole')"
                            type="text"
                            size="small"
                            @click="role(scope.row.id)"
                            >角色</el-button
                        >
                        <template v-if="$utils.have('/adminUser/editStatus')">
                            <el-button
                                v-if="scope.row.status == 1"
                                type="text"
                                size="small"
                                @click="editStatus(scope.row.id,0)"
                                >禁用</el-button
                            >
                            <el-button
                                v-else
                                type="text"
                                size="small"
                                @click="editStatus(scope.row.id,1)"
                                >启用</el-button
                            >
                        </template>
                        <el-button
                            v-if="$utils.have('/access/log/list')"
                            type="text"
                            size="small"
                            @click="log(scope.row.id)"
                            >行为日志</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <edit :data="userData" ref="userEdit" @update="getDataList"></edit>
        <role-edit ref="roleEdit" @update="getDataList"></role-edit>
    </div>
</template>
<script>
import Edit from './components/edit';
import RoleEdit from './components/roleEdit';
const defaultParams = {
    pageNo: 1,
    searchValue: '',
    searchType: 1,
    status: -1,
    department: ''
}

export default {
    components:{Edit,RoleEdit},
    data(){
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                status: parseInt(this.$route.query.status || -1),
                department: this.$route.query.department || '',
            },
            listLoading: true,
            userData:null,
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取用户列表
        getDataList(){
            this.listLoading = true;
            this.$request({
                url: '/adminUser/pageList',
                method: 'POST',
                data: this.params
            }).then(res => {
                const { state, msg, result } = res.data;
                if( state && result ){
                    this.data = result;
                    this.dataList = result.result || [];
                }else{
                    this.$message.error(msg || '请求失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            }).finally(() => {
                this.listLoading = false;
            });
        },
        //选择pageSize
        handleSizeChange( e ){
            this.params.pageNo = 1
            this.params.pageSize = e
            this.getDataList()
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //编辑状态
        editStatus(id,status){
            const _msg = status == 1 ? '确定要启用吗?' : '确定要禁用吗？';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/adminUser/editStatus',
                    method: 'POST',
                    data: {id:id,status:status}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            })
        },
        //编辑事件
        edit(id){
            this.getDetail(id);
            this.$refs.userEdit.show();
        },
        //新增事件
        add(){
            this.userData = null;
            this.$refs.userEdit.show();
        },
        //角色编辑事件
        async role(id){
            await this.getDetail(id);
            this.$refs.roleEdit.show(this.userData);
        },
        //获取详情
        async getDetail(id){
            const res = await this.$request({
                url: '/adminUser/detail',
                method: 'POST',
                data: {id:id}
            }).catch(() => {
                this.$message.error('请求错误');
            }).finally(() => {
                this.listLoading = false;
            });
            const { state, msg, result } = res.data;
            if( state == 1 ){
                this.userData = result;
                
            }else{
                this.$message.error(msg || '请求失败');
            }
        },
        //查看行为日志
        log(id){
            this.$router.push({
                path: `/system/adminUser/loginRecord?id=${id || ''}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            });
        }
    }
}
</script>